<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Factura</th>
            <th :class="StyleTh">Fecha Timbrado</th>
            <th :class="StyleTh">Cliente</th>
            <th :class="StyleTh">Total</th>
            <th :class="StyleTh">Forma de Pago</th>
            <th :class="StyleTh">Moneda</th>
            
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td><h6 :class="StylePr">{{lista.Serie+'-'+lista.Folio}}</h6></td>
                <td>
                    <p :class="StyleTd">{{lista.FechaTimbrado}}</p>
                </td>
                <td>
                    <p :class="StyleTd">{{lista.NombreCliente}}</p>
                </td>
                <td>
                    <p :class="StyleTd">$ {{$formatNumber(lista.Total)}}</p>
                </td>
                <td>
                    <p :class="StyleTd">{{lista.FormaPago}}</p>
                </td>
                <td>
                    <p :class="StyleTd">{{lista.Moneda}}</p>
                </td>
                
                <td class="align-middle text-end">
                    <!-- <template v-if="GetVisible(lista)"> -->
                        <button @click="SeleccionarFactura(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary"></i> Agregar</button>
                    <!-- </template> -->
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
        </template>
    </CList>
</template>

<script>

import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionFactura';

export default {
    name: 'ListaFacturas',
    props: ['poBtnSave'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: '',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                BtnNewShow: false,
                TitleFirst: '',
                ShowTitleFirst: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            Emit: this.poBtnSave.EmitSeccion,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ListaAgregados: [],
            IdCliente: 0,
            RFCcliente: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("facturas",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    Facturado: 'SI',
                    RegEstatus: 'A',
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        SeleccionarFactura(item)
        {
            console.log(item);
            let obj = {
                IdFactura: item.IdFactura,
                IdCotizacion: item.IdCotizacion,
                IdCliente: item.IdCliente,
                Folio: item.Serie+'-'+item.Folio,
                NombreCliente: item.NombreCliente,
                RfcCliente: item.RfcCliente,
                RegimenFiscalCliente: item.RegimenFiscalCliente,
                NumExtCliente: item.NumExtCliente,
                NumIntCliente: item.NumIntCliente,
                CPCliente: item.CPCliente,
                CalleCliente: item.CalleCliente,
                ColoniaCliente: item.ColoniaCliente,
                CiudadCliente: item.CiudadCliente,
                MunicipioCliente: item.MunicipioCliente,
                EstadoCliente: item.EstadoCliente,
                PaisCliente: item.PaisCliente,
                TelCliente: item.TelCliente,
                CorreoCliente: item.CorreoCliente,
                UUID: item.UUID,
            };

            this.bus.$emit('AgregarFacturaCredito',obj);
            this.bus.$emit('CloseModal_'+this.Emit);
        },
    },
    created()
    {
        this.bus.$off('List_'+EmitEjecuta);

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.IdCliente = obj.IdCliente;
            this.ListaAgregados = obj.Agregados;

            this.Lista();
        });
    },
    mounted()
    {
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });
    }
}
</script>